import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.previousFocus = document.activeElement
    this.onKeydown = event => this.handleKeydown(event)
    this.element.addEventListener("keydown", this.onKeydown)
    this.focusableElements()[0]?.focus()
  }

  disconnect() {
    this.element.removeEventListener("keydown", this.onKeydown)
    if (this.previousFocus?.isConnected) this.previousFocus.focus()
  }

  close() {
    this.element.remove()
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      event.preventDefault()
      this.close()
    } else if (event.key === "Tab") {
      const elements = this.focusableElements()
      const first = elements[0]
      const last = elements[elements.length - 1]
      if (!first) {
        event.preventDefault()
      } else if (event.shiftKey && document.activeElement === first) {
        event.preventDefault()
        last.focus()
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault()
        first.focus()
      }
    }
  }

  focusableElements() {
    return Array.from(this.element.querySelectorAll("a[href], button, input, select, textarea, [tabindex]"))
      .filter(element => !element.disabled && element.tabIndex >= 0 && element.getClientRects().length > 0)
  }
}
